export const PLANT_ID = '{plantId}'
export const PLANT_NAME = '{plantName}'
export const DASHBOARD_SEGMENT = 'dashboard'
export const SUMMARY_SEGMENT = 'summary'
export const PERFORMANCE_SEGMENT = 'performance'
export const TASKS_ASSIGNED_TO_ME_PARAM_KEY = 'assignedToMe'
